const CalculationUtils = {
  /*
   * CPI rent increase amount == <rent amount> x <CPI> (example: $1,000.00 x .022 =
   * $22.00)
   */
  rentIncreaseAmount(num, cpiPercent) {
    return (Number(Number(num).toFixed(2)) * Number(cpiPercent));
  },

  /**
   * Rent amount with standard rent increase == <rent amount> + Y1A (example: $1,000.00 + $22.00
   * = $1,022.00)
   */
  rentWithIncrease(x, y) {
    return (Number(Number(x).toFixed(2)) + Number(Number(y).toFixed(2))).toFixed(2);
  },

  /**
   * Maximum additional allowed rent increase for unit == Y1B x .03 OR <eligible amount> IF the
   * <eligible amount> is less than the Y1B x .03 (example: $30.60 OR $36.42 == $30.60 because this is
   * the lesser of the two values)
   */
  maxAdditionalIncrease(x, y) {
    return (Number(Number(x).toFixed(2)) * 0.03).toFixed(2) < Number(Number(y).toFixed(2)) ? Number(Number(x).toFixed(2)) * 0.03 : Number(Number(y).toFixed(2));
  },

  /**
   * Potential maximum rent amount with all increases applied == Y1B + Y1C (example: $1,022.00 +
   * $30.60 = $1,052.60)
   */
  rentWithAllIncreases(x, y) {
    return Number(Number(x).toFixed(2)) + Number(Number(y).toFixed(2));
  },

  /**
   * Remaining eligible amount for second year = <eligible amount> - Y1C (example: $36.42 - $30.60
   * = $5.7
   */
  remainingAmount(x, y) {
    return Number(Number(x).toFixed(2)) - Number(Number(y).toFixed(2)) > 0 ? Number(Number(x).toFixed(2)) - Number(Number(y).toFixed(2)) : 0;
  },

  getCpiForYear(cpiConfig, year) {
    const cpi = cpiConfig.yearly_cpis.find((val) => {
      return val.year.toString() === String(year);
    });

    return cpi;
  },
};

export default CalculationUtils;
